<template>
  <div class="activity-po-wo-wrap" :key="rerenderKey">
    <slot name="default" :autoSaveMiddleware="autoSaveMiddleware" />
    <dialog-order-phase
      v-if="isOpenDialogOrderPhase"
      :salesOrderIDList="salesOrderIDList"
      :isLoading.sync="isLoading"
      :showPoOpen="showPoOpen"
      @onClose="_closeDialogs"
      @onAutoSave="handleAutoSave"
      @onSuccess="handleSuccessOrderPhase"
      @onSuccessWithoutClosing="continueOrderPhaseAutoSave"
    />
    <dialog-quote-approved
      v-if="isOpenQuoteApproved"
      :salesOrderIDList="salesOrderIDList"
      :isLoading.sync="isLoading"
      @onClose="_closeDialogs"
      @onAutoSave="handleAutoSave"
      @onSuccess="handleSuccessQuoteApproved"
    />
  </div>
</template>

<script>
import { ServiceSalesOrders } from '@/services/SalesOrders'
import { ServiceRFQs } from '@/services/RFQs'
export const FINISHED_CLOSED_ORDER_PHASE_ID = 15

export default {
  name: 'ActivityPoWoWrap',
  components: {
    'dialog-order-phase': () => import(/* webpackChunkName: 'Shared' */ './DialogOrderPhase'),
    'dialog-quote-approved': () => import(/* webpackChunkName: 'Shared' */ './DialogQuoteApproved')
  },
  props: {
    orderPhaseUpdate: {
      type: String,
      default: 'SALES_ORDER'
    },
    rfqID: {
      required: true
    },
    handleAutoSave: {
      type: Function,
      default: () => ({})
    },
    showPoOpen: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      rerenderKey: 0,
      isLoading: false,
      isOpenDialogOrderPhase: false,
      isOpenQuoteApproved: false,
      salesOrderID: null,
      salesOrderIDList: [],
      autoSaveProps: {}
    }
  },
  methods: {
    autoSaveMiddleware (props) {
      const { field, value } = props
      if (field === 'orderPhaseID' && value === FINISHED_CLOSED_ORDER_PHASE_ID) {
        this._openDialogOrderPhase()
        this.autoSaveProps = props
      } else if (field === 'quoteApproved' && value === true) {
        this._openDialogQuoteApproved()
        this.autoSaveProps = props
      } else {
        this.handleAutoSave(props)
      }
    },
    async _openDialogQuoteApproved () {
      try {
        await this._getSalesOrderID()
        this.isOpenQuoteApproved = true
      } catch (e) {
        this.requestErrorHandler(e, e.message)
        this.handleAutoSave(this.autoSaveProps)
      }
    },
    async _openDialogOrderPhase () {
      try {
        if (this.orderPhaseUpdate === 'SALES_ORDER') {
          await this._getSalesOrderID()
        }
        this.isOpenDialogOrderPhase = true
      } catch (e) {
        this.requestErrorHandler(e, e.message)
        this.handleAutoSave(this.autoSaveProps)
      }
    },
    _reset () {
      this.isLoading = false
      this.isOpenDialogOrderPhase = false
      this.isOpenQuoteApproved = false
      this.salesOrderIDList = []
    },
    _closeDialogs () {
      this._reset()
      this.rerenderKey++
    },
    continueOrderPhaseAutoSave () {
      this.handleAutoSave({ ...this.autoSaveProps })
      this.requestSuccessHandler()
      this._reset()
    },
    async handleSuccessOrderPhase (data) {
      switch (this.orderPhaseUpdate) {
        case 'SALES_ORDER': {
          await this.updatePhaseSalesOrder(data)
          break
        }
        case 'RFQ': {
          await this.updateRfq(data)
        }
      }
      this.continueOrderPhaseAutoSave()
    },
    handleSuccessQuoteApproved () {
      this.handleAutoSave({ ...this.autoSaveProps })
      this.requestSuccessHandler()
      this._reset()
    },

    async updateRfq (data) {
      return ServiceRFQs.patch({ id: this.rfqID, orderRatingScoreID: data.scoreID, pOisOpen: false })
    },

    async _getSalesOrderID () {
      this.isLoading = true
      if (!this.rfqID) {
        return Promise.reject(new Error('Unexpected behaviour'))
      }
      return ServiceSalesOrders
        .getAllDynamic({
          select: 'id',
          filter: `rfq.id == ${this.rfqID}`
        })
        .then(({ data }) => {
          if (data.value.length === 0) {
            throw new Error(this.L10n('sales-order-is-not-exist'))
          } else {
            this.salesOrderIDList = data.value.map(({ id }) => id)
          }
          this.isLoading = false
        })
    },
    async updatePhaseSalesOrder (data) {
      return Promise.all(
        this.salesOrderIDList.map((id) => {
          return ServiceSalesOrders
            .patch({
              id,
              ...data
            })
            .catch((err) => {
              this.requestErrorHandler(err)
            })
        })
      )
    }
  }
}
</script>
<style lang="stylus">
  .activity-po-wo-wrap{
    &__footer{
      display: flex;
      align-items flex-end;
      justify-content flex-end;
    }
  }
</style>
